import project1 from "../assets/projects/project-1.png";
import project2 from "../assets/projects/project-2.png";
import project3 from "../assets/projects/project-3.png";
import project5 from "../assets/projects/project-5.png";
import project6 from "../assets/projects/project-6.png";
import project7 from "../assets/projects/project-7.png";
import ease from "../assets/projects/ease.jpg";

export const HERO_CONTENT = `I'm Mafruha Manal, currently a senior in Computer Science at UB. I like to dabble in a whole lot of Full-stack web development 👩🏽‍💻 Always cooking up a storm and looking for new things to build

`;

export const ABOUT_TEXT = `I'm currently located in Buffalo, NY, studying as an undergraduate student in CS with a specialization in Software Systems!
 Outside of programming, I love to do digital art, watch k-drama and play video games for fun`;

export const EXPERIENCES = [
  {
    year: "May 2026 - Aug 2026",
    role: "Software Engineer Intern",
    company: "Netflix",
    description: "Built a real-time TV Player trace logging pipeline in TypeScript that cut production debugging time by 85%. Engineered a buffering system to handle 100k console trace logs per ms with 0% data loss, re-designing the event buffer and flush mechanism to keep pace with high throughput playback sessions.",
    technologies: ["TypeScript"]
  },
  {
    year: "Apr 2025 - Aug 2025",
    role: "Software Engineer Fellow",
    company: "Formation",
    description:
      "Received the Rising Tide Award for outstanding collaboration in pair programming and code review. Completed 350+ hours of training in data structures and distributed systems design, conducting 3 weekly data modelling and design drills across the 16-week program.",
    technologies: ["Java", "System Design", "DBMS"],
  },
  {
    year: "Dec 2024 - Aug 2025",
    role: "Software Engineer Fellow",
    company: "Uber",
    description:
      "Selected as 1 of 50 software engineering fellows for 2025 Uber Career Prep cohort. Participate in 15 mock interviews in Python with senior engineers, enhancing data structures and algorithm skills. Complete technical assignments and attend 1:1 meetings with mentors to track progress through a 9-month period.",
    technologies: ["Python", "Data Structures & Algorithms"],
  },
  {
    year: "Aug 2024 - Present",
    role: "Undergraduate Teaching Assistant",
    company: "University at Buffalo",
    description:
      "Assist 2 professors in teaching 260 students object-oriented programming in Java by hosting 4 weekly office hours. Instruct 25 students in a weekly lab, proctor exams, and enhance comprehension of 9 data structure concepts. Clarify student questions received from a coding forum.",
    technologies: ["Java", "JUnit", "Object-oriented Programming"],
  },
  {
    year: "June 2024 - May 2025",
    role: "Software Developer Intern",
    company: "X Lab",
    description: `Developed a cross-platform mobile app in React Native to monitor indoor farms at the lab with Augmented Reality. Implement backend logic in C# for touch detection, rotation and pinch-to-scale interactions with 3D models. Built a coordinate-specific metric display for 3D plant models to monitor plant health and identify signs of diseases/deficiencies.`,
    technologies: ["React_Native", "Firebase", "Unity", "C#", "Javascript"],
  },
  {
    year: "July 2024 - September 2024",
    role: "Undergraduate Research Aide",
    company: "University at Buffalo",
    description: `Maintain Wireless Topology Tool, a Flask web app for topology simulation to integrate real geographic data for wireless network research. Integrate a dynamic display feature for NS3 simulation results by transforming large JSON topology data`,
    technologies: ["Flask", "MySQL", "JavaScript", "Python"],
  }
];

export const PROJECTS = [
   {
    title: "EAS&E - Best AI/ML Hack @ UB Hacking 2025",
    image: ease,
    description:
      "Built a platform for AI-assisted wrist and posture exercises to alleviate arthritis pain. Implemented a RAG-based voice agent to guide you through the website and exercises. The wrist and posture exercises, consisted of real-time tracing for pre-computed movements, and a feature that lets you build your own custom traces as well",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "Eleven Labs",
      "MediaPipe",
      "Gemini"
    ],
  },
  {
    title: "BenefitForAll - J.P. Morgan Code for Good 2024",
    image: project7,
    description:
      "Developed a web app in team of 8 for a non-profit, First Gen Investors, to enhance financial literacy for high school students. Leveraged Firebase and AG Grid for data retrieval and CSV generation, reducing report creation time by an hour. 1 of 73 students invited to participate in JP Morgan Chase's Code for Good in Jersey City.",
    technologies: [
      "React",
      "Vite",
      "Firebase",
      "Chart.js",
      "AG Grid",
      "Material UI",
    ],
  },
  {
    title: "AI Valorant Chatbot",
    image: project6,
    description:
      "The AI chat assistant delivers contextual responses to user queries, providing in-game strategies to rank up, finding the right weapons, or learning more about agents, abilities and gameplay. Implemented RAG, leveraging LangChain for knowledge base management and storing vector embeddings in Supabase for retrieval",
    technologies: [
      "Nextjs",
      "OpenAI",
      "LangChain",
      "Supabase Vector Store",
      "Material UI",
    ],
  },
  {
    title: "Mama Well App",
    image: project1,
    description:
      "Developed an iOS care app for postpartum mothers with Honorable Mentions at the 2024 Black Wings Hacks. Integrated features for tracking common post-labor symptoms and monitoring water intake to promote self-care. Implemented a booking system with integrated reminders for doctor appointments or check-ins post-labor",
    technologies: ["React Native", "Firebase", "Firestore", "Expo"],
  },
  {
    title: "Clay Clutter App",
    image: project2,
    description:
      "Built a full-stack CRUD web app for pottery artists to help accelerate pottery documentation and progress. Implemented essential features including user registration, customizable clay progress stages, and content feeds. Authenticated users with JSON Web Tokens and bcrypt hashing to facilitate secure user logins.",
    technologies: ["React", "MongoDB", "Express.js", "Node.js"],
  },
  {
    title: "Auto-Sneakers Bot",
    image: project5,
    description:
      "Wrote a Python script to send WhatsApp alerts any time a pair of limited edition trainers is available in my size. Automatically adds the item to my shopping cart on eBay, streamlining my purchasing processes to minimize the risk of missing highly sought-after products!",
    technologies: ["Python", "Selenium", "BeautifulSoup", "Pywhatkit"],
  },
  {
    title: "Personal Website",
    image: project3,
    description:
      "A simple portfolio website to share a little about myself, my tech ventures and the lil side projects I've done ✨",
    technologies: ["React", "JavaScript", "Tailwind CSS", "Framer Motion"],
  },
];
